import React from 'react';
import { Helmet } from 'react-helmet-async';

class StoreFrontHelmet extends React.Component {
    componentDidMount() {
        this.props.context?.configuration?.gtm && this.injectGtm();
        this.props.context?.configuration?.metaPixelKey && this.injectMetaPixel();
    }

    injectGtm = () => {
        const body = document.getElementsByTagName('body')[0];
        const openComment = document.createComment(' Google Tag Manager (noscript) ');
        const noscript = document.createElement('noscript');
        const closeComment = document.createComment(' End Google Tag Manager (noscript) ');
        const iframe = document.createElement('iframe');
        iframe.setAttribute(
            'src',
            `https://www.googletagmanager.com/ns.html?id=${this.props.context.configuration.gtm}`,
        );
        iframe.setAttribute('width', '0');
        iframe.setAttribute('height', '0');
        iframe.setAttribute('style', 'display:none;visibility:hidden');

        body.prepend(openComment);
        body.insertBefore(noscript, openComment.nextSibling);
        body.insertBefore(closeComment, noscript.nextSibling);
        noscript.appendChild(iframe);
    };

    injectMetaPixel = () => {
        const body = document.getElementsByTagName('body')[0];
        const openComment = document.createComment(' Meta Pixel Code (noscript) ');
        const noscript = document.createElement('noscript');
        const closeComment = document.createComment(' End Meta Pixel Code (noscript) ');
        const img = document.createElement('img');

        img.setAttribute('height', '1');
        img.setAttribute('width', '1');
        img.setAttribute('style', 'display:none');
        img.setAttribute(
            'src',
            `https://www.facebook.com/tr?id=${this.props.context.configuration.metaPixelKey}&ev=PageView&noscript=1`,
        );

        body.appendChild(openComment);
        body.appendChild(noscript);
        body.appendChild(closeComment);
        noscript.appendChild(img);
    };

    getTags = () => {
        return (
            <Helmet>
                <link href='https://calendly.com/assets/external/widget.css' rel='stylesheet' />
                <script src='https://calendly.com/assets/external/widget.js' type='text/javascript' />

                {this.props.context?.configuration?.gtm && (
                    <script>
                        {`
                            (function(w,d,s,l,i){w[l] = w[l] || [];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','${this.props.context.configuration.gtm}');
                            `}
                    </script>
                )}

                {this.props.context?.configuration?.contentSquareKey && (
                    <script type='text/javascript'>
                        {`
                            (function () {
                                window._uxa = window._uxa || [];
                                if (typeof CS_CONF === "undefined") {
                                    window._uxa.push([
                                        "setPath",
                                        window.location.pathname + window.location.hash.replace("#", "?__")
                                    ]);
                                    var mt = document.createElement("script");
                                    mt.type = "text/javascript";
                                    mt.async = true;
                                    mt.src = "//t.contentsquare.net/uxa/${this.props.context.configuration.contentSquareKey}.js";
                                    document.getElementsByTagName("head")[0].appendChild(mt);
                                } else {
                                    window._uxa.push([
                                        "trackPageview",
                                        window.location.pathname + window.location.hash.replace("#", "?__")
                                    ]);
                                }
                            })();
                    `}
                    </script>
                )}

                {this.props.context?.configuration?.metaPixelKey && (
                    <script>
                        {`
                            !function(f,b,e,v,n,t,s)
                            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                            n.queue=[];t=b.createElement(e);t.async=!0;
                            t.src=v;s=b.getElementsByTagName(e)[0];
                            s.parentNode.insertBefore(t,s)}(window, document,'script',
                            'https://connect.facebook.net/en_US/fbevents.js');
                            fbq('init', '${this.props.context.configuration.metaPixelKey}');
                            fbq('track', 'PageView');
                        `}
                    </script>
                )}

                {this.props.context?.storefront?.customAnalytics && (
                    <script async type={'text/javascript'}>
                        {`
                           ${this.props.context?.storefront?.customAnalytics}
                        `}
                    </script>
                )}
            </Helmet>
        );
    };

    render() {
        return this.getTags();
    }
}

export default StoreFrontHelmet;
